import { createSlice } from "@reduxjs/toolkit";

const initialPermissionSetState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    permissionSetForEdit: undefined,
    lastError: null,
    message: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const permissionSetSlice = createSlice({
    name: "permissionSets",
    initialState: initialPermissionSetState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error.clientMessage;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            state.message = null;

            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            state.message = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        // getPermissionSetById
        permissionSetFetched: (state, action) => {
            state.actionsLoading = false;
            state.permissionSetForEdit = action.payload.permissionSetForEdit;
            state.error = null;

        },
        // get list data
        permissionSetsFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
            state.permissionSetForEdit = undefined;
        },
        // createPermissionSet
        permissionSetCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        // updatePermissionSet
        permissionSetUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.message = action.payload.msgResponse;
        },
        // permissionSetDeleted
        permissionSetDeleted: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
            state.actionsLoading = false;
        },
        setMessage: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
        },

    }
});
